import { useEffect, useState } from 'react'
import axios from 'axios'

export function Opportunities() {
  const [opportunities, setOpportunities] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  
  useEffect(() => {
    fetchOpportunities()
  }, [])
  
  const fetchOpportunities = async () => {
    try {
      const response = await axios.get('https://api.finapp.aerotage.com/api/opportunities')
      setOpportunities(response.data.opportunities || [])
    } catch (error) {
      console.error('Failed to fetch opportunities:', error)
    } finally {
      setLoading(false)
    }
  }
  
  if (loading) {
    return <div className="text-center py-12">Loading opportunities...</div>
  }
  
  return (
    <div className="space-y-6">
      <div className="bg-white shadow rounded-lg p-6">
        <h2 className="text-2xl font-bold mb-4">Detected Opportunities</h2>
        
        {opportunities.length === 0 ? (
          <div className="text-center py-12 text-gray-500">
            <p className="text-lg">No opportunities detected yet.</p>
            <p className="text-sm mt-2">The system is monitoring your watchlist...</p>
          </div>
        ) : (
          <div className="space-y-4">
            {opportunities.map((opp) => (
              <div key={opp.id} className={`border rounded-lg p-4 ${
                opp.priority === 'critical' ? 'border-red-500 bg-red-50' :
                opp.priority === 'high' ? 'border-yellow-500 bg-yellow-50' :
                'border-gray-300 bg-white'
              }`}>
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <div className="flex items-center space-x-3">
                      <span className="text-xl font-bold">{opp.ticker}</span>
                      <span className="text-sm text-gray-600">{opp.opportunity_type.replace('_', ' ')}</span>
                      <span className={`px-2 py-1 rounded text-xs font-semibold ${
                        opp.priority === 'critical' ? 'bg-red-200 text-red-800' :
                        opp.priority === 'high' ? 'bg-yellow-200 text-yellow-800' :
                        'bg-gray-200 text-gray-800'
                      }`}>
                        {opp.priority.toUpperCase()}
                      </span>
                    </div>
                    <p className="mt-2 text-gray-700">{opp.trigger_reason}</p>
                    <div className="mt-2 flex items-center space-x-4 text-sm text-gray-600">
                      <span>Confidence: {(opp.confidence * 100).toFixed(0)}%</span>
                      <span>Price: ${opp.current_price?.toFixed(2)}</span>
                      {opp.price_change_percent && (
                        <span className={opp.price_change_percent > 0 ? 'text-green-600' : 'text-red-600'}>
                          {opp.price_change_percent > 0 ? '+' : ''}{opp.price_change_percent.toFixed(2)}%
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="text-right text-sm text-gray-500">
                    {new Date(opp.detected_at).toLocaleString()}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

